export const BIFOLD_MIN_PANELS = 2;
export const BIFOLD_MAX_PANELS = 79; // Existing 1,200in preview width / 15in minimum panel.
export const BIFOLD_JAMB_IN = .08 / .0254;
export const LEGACY_BIFOLD_SPLITS = ['1+1', '2+1', '2+2', '3+1'];
export const bifoldCount = layout => (layout || '3+0').split('+').reduce((sum, n) => sum + Number(n), 0);
export const bifoldSide = layout => {
  const [left, right] = (layout || '3+0').split('+').map(Number);
  return left && right ? 'split' : right ? 'right' : 'left';
};
export const bifoldLayout = (count, side) => side === 'right' ? `0+${count}` : `${count}+0`;
export const bifoldWidthRange = count => ({ min: Math.ceil(15 * count + BIFOLD_JAMB_IN), max: Math.min(1200, Math.floor(48 * count + BIFOLD_JAMB_IN)) });
export const bifoldPanelRange = width => ({ min: Math.max(2, Math.ceil((Number(width) - BIFOLD_JAMB_IN) / 48)), max: Math.min(BIFOLD_MAX_PANELS, Math.floor((Number(width) - BIFOLD_JAMB_IN) / 15)) });
export const bifoldDescription = layout => {
  const [left, right] = (layout || '3+0').split('+').map(Number);
  return left && right ? `${left + right} panels · ${left} left / ${right} right` : `${left + right} panels · stack ${right ? 'right' : 'left'}`;
};
export const upgradeBifoldDraft = design => ['vlx100-bifold', 'es82-bifold'].includes(design.model_id) && design.bifold_layout === '1+0'
  ? { ...design, bifold_layout: '2+0', run_a: { ...design.run_a, panels: 2 } } : design;